/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import {
  Image, ImageProps,
} from '@doveit/lego';
import * as styles from './MiniInfoBlock.style';

export interface MiniInfoBlockProps {
  image: ImageProps,
  title: string,
  description?: string,
}

const MiniInfoBlock: React.FC<MiniInfoBlockProps> = ({
  image,
  title,
  description,
}) => (
  <article
    css={styles.base}
  >
    <div css={styles.image}>
      <Image
        src={image.src}
        alt={image.alt}
        loading="lazy"
      />
    </div>
    <div css={styles.info}>
      <div css={styles.title}>
        {title}
      </div>
      {description && (
        <div
          css={styles.description}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
    </div>
  </article>
);

export default MiniInfoBlock;
